import React, { useEffect, useState } from 'react';
import { useHawkSearch } from 'components/StoreProvider';
import ToolRow from 'components/ui/Results/ToolRow';
import ResultItem, { ResultItemProps } from 'components/ui/Results/ResultItem';
import SearchResultsLabel from 'components/ui/Facets/SearchResultsLabel';
import NoResults from './NoResults';
import CompareItemsBar from 'components/compare-items/CompareItemsBar';
import classnames from 'classnames';
import { ScrollToResults } from 'features/search/FacetsAndResults';
import ListSVG from 'shared/components/svg/ListSVG';
import GridSVG from 'shared/components/svg/GridSVG';
import ResultListingHCL from './ResultListing.HCL';
export interface ResultsProps {
	resultItem?: React.ComponentType<ResultItemProps>;
}
import { GetProductsPriceDetails, ProductPriceResponse } from './data.HCL';

function ResultsHCL({ resultItem = ResultItem, scrollToResults }: ResultsProps & ScrollToResults) {
	const {
		store: { isLoading, searchResults, requestError, itemsToCompare },
	} = useHawkSearch();

	const [listView, ShowListView] = useState(false);
	const [pricingAndAvailability, setPricingAndAvailability] = useState<ProductPriceResponse>();
	const [isLoadingPricing, setIsLoadingPricing] = useState(false);

	useEffect(() => {
		if (searchResults?.Results) {
			setIsLoadingPricing(true);

			(async () => {
				try {
					const response = await GetProductsPriceDetails(searchResults?.Results);
					if (response) {
						setPricingAndAvailability(response);
					}
				} catch (error) {
					// Handle error if necessary
				} finally {
					setIsLoadingPricing(false);
				}
			})();
		}
	}, [searchResults]);

	if (requestError) {
		return <span>An error occurred while searching for your results. Please contact the site administrator.</span>;
	}

	if ((!searchResults || searchResults.Results.length === 0) && !isLoading) {
		return <NoResults />;
	}

	const ToggleResultView = (elem) => {
		ShowListView(!listView);

		const controlBtn = document.querySelectorAll('.hawk-results-view-results-controls-btn');

		controlBtn.forEach((element) => {
			element.classList.remove('active');
		});

		elem.currentTarget.classList.add('active');
	};

	return (
		<div
			className={classnames('hawk-results', {
				'hawk-results--loading': isLoading,
				'hawk-results__list-view': listView,
			})}
		>
			<SearchResultsLabel />

			<div className="hawk-results__top-tool-row">
				<ToolRow scrollToResults={scrollToResults} />

				<div className="hawk-results-view-results-controls">
					<button
						className="hawk-results-view-results-controls-btn active"
						onClick={ToggleResultView}
						disabled={!listView}
					>
						<GridSVG />
					</button>
					<button
						className="hawk-results-view-results-controls-btn"
						onClick={ToggleResultView}
						disabled={listView}
					>
						<ListSVG />
					</button>
				</div>
			</div>

			<div className="roc-visually-hidden" role="status">
				{itemsToCompare && itemsToCompare.length > 0 && 'Compare Bar Avaliable on Top of Listing'}
			</div>

			{itemsToCompare && itemsToCompare.length > 0 && <CompareItemsBar />}

			<ResultListingHCL
				resultItem={resultItem}
				pricingAndAvailability={pricingAndAvailability}
				isLoadingPricing={isLoadingPricing}
			/>

			<div className="hawk-results__bottom-tool-row">
				<ToolRow scrollToResults={scrollToResults} />
			</div>
		</div>
	);
}

export default ResultsHCL;
